<div class="category-card bg-white">
  <!-- Category Header -->
  <div class="category-header primary-bg-0 heading-secondary"
       [class.master-category]="isMasterCategory"
       [class.custom-category]="!isMasterCategory">
    <div class="header-content">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" class="header-main">
        <mat-icon class="category-icon">{{categoryIcon}}</mat-icon>
        <div fxFlex class="category-info">
          <h3 class="category-title">{{displayName}}</h3>
          <p *ngIf="displayDescription" class="category-description">{{displayDescription}}</p>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
          <span class="selection-count">{{selectedCount}}/{{totalCount}}</span>
          <button mat-icon-button [matMenuTriggerFor]="categoryMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Category Menu -->
    <mat-menu #categoryMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="selectAllIndustries()"
              [disabled]="!(selectedCount < totalCount && totalCount > 0)">
        <mat-icon>check_box</mat-icon>
        Select All
      </button>
      <button mat-menu-item (click)="selectNoneIndustries()"
              [disabled]="!(selectedCount > 0 && selectedCount < totalCount)">
        <mat-icon>select</mat-icon>
        Select None
      </button>

      <mat-divider></mat-divider>

      @if(showPagination){
        @if(!showAll){
          <button mat-menu-item (click)="showAllIndustries()"
                  [disabled]="showAll">
            <mat-icon>expand</mat-icon>
            Show all ({{ totalCount }})
          </button>
        }@else {
          <button mat-menu-item (click)="collapseIndustries()"
                  [disabled]="!showAll">
            <mat-icon>hide</mat-icon>
            Collapse
          </button>
        }
      }
    </mat-menu>

  </div>

  <!-- Expanded Content -->
  <div class="category-content fx-col" *ngIf="isExpanded">
    <!-- Category Controls -->
    <div class="category-controls" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" fxFlexOffset="20px">
      <button class="button-action" mat-flat-button (click)="startEditing()" [disabled]="(loader.loading$ | async) || isEditing">
        <span class="button-text">Edit</span>
      </button>
      <button class="button-action" mat-flat-button (click)="addNewIndustry()" [disabled]="(loader.loading$ | async) || isEditing">
        <span class="button-text">Add Industry</span>
      </button>
      <span class="fx-spacer"></span>
      <span class="industry-category-card-selected-toggle-container">
        <span class="pr-10">{{ category.selected ? 'Visible' : 'Hidden' }}</span>
        <mat-slide-toggle
                          color="primary"
                          labelPosition="before"
                          [(ngModel)]="category.selected"
                          (ngModelChange)="onCategorySelectionChange()"
                          [disabled]="(loader.loading$ | async) || isEditing">
        </mat-slide-toggle>
      </span>
    </div>

    <!-- Category Details Display -->
    <div class="category-details" *ngIf="!isEditing">
      <div class="detail-row">
        <span class="detail-label">Name:</span>
        <span class="detail-value">{{displayName}}</span>
        <span *ngIf="category.labelNameOverride && isMasterCategory" class="original-value">({{category.name}})</span>
      </div>
      <div class="detail-row" *ngIf="displayDescription">
        <span class="detail-label">Description:</span>
        <span class="detail-value">{{displayDescription}}</span>
        <span *ngIf="category.labelDescriptionOverride && isMasterCategory" class="original-value">({{category.description}})</span>
      </div>
    </div>

    <!-- Edit Form -->
    <div class="edit-form" *ngIf="isEditing" [formGroup]="editForm" fxLayout="column" fxLayoutGap="32px">
      <mat-form-field class="custom-text-field full-width-i" appearance="outline" floatLabel="always">
        <mat-label>Custom label</mat-label>
        <input matInput formControlName="labelName" [placeholder]="category.name">
        <mat-icon matSuffix class="reset-icon" (click)="resetLabelNameToDefault()"
                  matTooltip="Reset to default">
          refresh
        </mat-icon>
        <mat-hint *ngIf="isMasterCategory">Original: {{category.name}}</mat-hint>
        <mat-error *ngIf="editForm.get('labelName')?.hasError('maxlength')">
          Label name cannot exceed 100 characters
        </mat-error>
      </mat-form-field>

      <mat-form-field class="custom-text-field full-width-i" appearance="outline" floatLabel="always">
        <mat-label>Custom description</mat-label>
        <input matInput formControlName="labelDescription" [placeholder]="category.description || 'Enter description'">
        <mat-icon matSuffix class="reset-icon" (click)="resetLabelDescriptionToDefault()"
                  matTooltip="Reset to default">
          refresh
        </mat-icon>
        <mat-hint *ngIf="isMasterCategory && category.description">Original: {{category.description}}</mat-hint>
        <mat-error *ngIf="editForm.get('labelDescription')?.hasError('maxlength')">
          Description cannot exceed 500 characters
        </mat-error>
      </mat-form-field>

      <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="end center" class="full-width">
        <button class="button-action-cancel" mat-flat-button (click)="cancelEditing()" [disabled]="!canCancel">
          <div class="button-text">Cancel</div>
        </button>
        <button class="button-action" mat-flat-button color="primary" (click)="saveEditing()" [disabled]="!canSave">
          <div class="button-text">Save</div>
        </button>
      </div>
    </div>

    <!-- Industries List -->
    <div class="industries-list" *ngIf="!isEditing">
      <app-industry-item
        *ngFor="let industry of paginatedIndustries; trackBy: trackByIndustryId"
        [industry]="industry"
        (industryChanged)="onIndustryChanged($event)">
      </app-industry-item>

      <!-- Pagination Controls -->
      <div class="pagination-controls">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="pagination-container">
          <button mat-button disabled>
            {{category.selected ? 'Visible' : 'Hidden'}}
          </button>

          @if(showPagination){
            @if(!showAll){
              <div>
              <button mat-button (click)="prevPage()" [disabled]="currentPage <= 1">
                Previous
              </button>

              <span class="page-info">
                {{ currentPage }} of {{ totalPages }}
              </span>

              <button mat-button (click)="nextPage()" [disabled]="currentPage >= totalPages">
                Next
              </button>
              </div>
              <button mat-button (click)="showAllIndustries()" *ngIf="!showAll">
                Show all ({{ totalCount }})
              </button>
            }@else {
              <button mat-button (click)="collapseIndustries()" *ngIf="showAll">
                Collapse
              </button>

              <button mat-button disabled>
                All ({{ totalCount }})
              </button>
            }
          } @else {
            <button mat-button disabled>
              All ({{ totalCount }})
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
